export default "__VITE_ASSET__BQrOlIVz__"